import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, FormBuilder, Validators } from "@angular/forms";
import { ActivatedRoute, Router } from '@angular/router';
import { environment } from '../../../../environments/environment';
import { AuthenticationService, DataService, ToastrService } from '../../../_services/index';


@Component({
    selector: 'app-register',
    templateUrl: './register.component.html',
    styleUrls: ['./register.component.css'],
    providers: [ToastrService]
})
export class RegisterComponent implements OnInit {

    model: any = {};
    inpArray: Array<any> = [];
    loading = false;
    returnUrl: string;
    errorMessage: any;
    usersForm: FormGroup;
    email: FormControl;
    cemail: FormControl;
    password: FormControl;
    cpassword: FormControl;
    _BTNcolor: string;
    redemptionParams: any;
    redemptionParamsStringified: string;
    lpExtenstionValue: boolean;

    constructor(private activatedRoute: ActivatedRoute,
        private router: Router,
        private _dataService: DataService,
        private authenticationService: AuthenticationService,
        private _toastrService: ToastrService,
        private fb: FormBuilder) {
        this.activatedRoute.queryParams.subscribe(p => {
            this.redemptionParamsStringified = (p['redemptionParams'] || '');
            this.redemptionParams = JSON.parse((p['redemptionParams'] || '{}'));
        });
    }

    ngOnInit() {
        this._BTNcolor = '#333';
        this.createFormControls();
        this.createForm();
        this.lpExtenstionValue = true;
        //this.authenticationService.logout();
        (<any>window).gtag('config', environment.gaId, { 'page_path': `/register` });
    }

    createFormControls() {
        this.email = new FormControl('', {
            validators: [Validators.required,
            Validators.pattern("[^ @]*@[^ @]*")],
            // updateOn: 'submit'
            updateOn: 'change'
        });
        this.cemail = new FormControl('', {
            validators: [Validators.compose(
                [Validators.required, this.validateAreEqual.bind(this, this.email)]
            )],
            // updateOn: 'submit'
            updateOn: 'change'
        });
        this.password = new FormControl('', {
            validators: Validators.required,
            // updateOn: 'submit'
            updateOn: 'change'
        });
        this.cpassword = new FormControl('', {
            validators: [Validators.compose(
                [Validators.required, this.validateAreEqual.bind(this, this.password)]
            )],
            // updateOn: 'submit'
            updateOn: 'change'
        });
    }

    private validateAreEqual(fieldControl: FormControl, fieldControl1: FormControl) {
        if (fieldControl) {
            return fieldControl.value === fieldControl1.value ? null : {
                NotEqual: true
            };
        }

    }

    private createForm() {
        this.usersForm = new FormGroup({
            email: this.email,
            cemail: this.cemail,
            password: this.password,
            cpassword: this.cpassword
        });
    }

    onSubmit() {
        const formData = this.usersForm["controls"];
        formData['email'].markAsTouched();
        formData['cemail'].markAsTouched();
        formData['password'].markAsTouched();
        formData['cpassword'].markAsTouched();
    }

    createAccount(form) {
        const formData = form.value;
        if (!this.usersForm.valid) {
            this.onSubmit();
            return;
        }
        this.loading = true;
        const url = '/api/createAccount';
        const body = {
            email: formData.email,
            password: formData.password,
            cpassword: formData.cpassword
        };
        this._dataService.post(url, body)
            .subscribe(
                (data: { data: any, response: string, response_message: Array<any> }) => {
                    if (data.response === 'success') {
                        if (data.data.insertId) {
                            // this.lpExtenstionValue = true;
                            // setTimeout(() => {
                            localStorage.setItem('newuserinsertId', data.data.insertId);
                            this.router.navigate(['new-user'], { queryParams: { "redemptionParams": this.redemptionParamsStringified } });
                            // }, 0);
                        }

                        (<any>window).gtag('event', 'Click', {
                            'event_category': 'Button Clicked',
                            'event_label': `Create Account Button by User ID ${data.data.insertId} (${formData.email})`
                        });
                    }
                },
                (error) => {
                    this._toastrService.typeCustomError(error.error.response_message || error.status_text);
                    this.loading = false;
                    this.router.navigate(['login']);
                });
    }

}



// WEBPACK FOOTER //
// ./public/app/modules/login/register/register.component.ts